export function filterItems(item, searchText, key = "title") {
  return item?.[key]?.toLowerCase().includes(searchText.toLowerCase());
}
